import { PrimaryButton } from '@/components';
import { Stack, Typography } from '@mui/material';
import { DeleteButton } from './Filters.components';

export const EditExperienceHeader = () => {
  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack>
        <Typography fontSize={14}>asdsadas</Typography>
        <Typography fontSize={13} color="gray300">
          Update details or delete experience
        </Typography>
      </Stack>
      <Stack direction="row" gap={2}>
        <PrimaryButton>
          <Typography fontSize={13}>Save</Typography>
        </PrimaryButton>
        <DeleteButton>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginRight: 5 }}
          >
            <path
              d="M13.3433 4.00065H10.6767V3.33398C10.6767 2.80355 10.466 2.29484 10.0909 1.91977C9.71582 1.5447 9.20711 1.33398 8.67668 1.33398H7.34334C6.81291 1.33398 6.3042 1.5447 5.92913 1.91977C5.55406 2.29484 5.34334 2.80355 5.34334 3.33398V4.00065H2.67668C2.49987 4.00065 2.3303 4.07089 2.20527 4.19591C2.08025 4.32094 2.01001 4.49051 2.01001 4.66732C2.01001 4.84413 2.08025 5.0137 2.20527 5.13872C2.3303 5.26375 2.49987 5.33398 2.67668 5.33398H3.34334V12.6673C3.34334 13.1978 3.55406 13.7065 3.92913 14.0815C4.3042 14.4566 4.81291 14.6673 5.34334 14.6673H10.6767C11.2071 14.6673 11.7158 14.4566 12.0909 14.0815C12.466 13.7065 12.6767 13.1978 12.6767 12.6673V5.33398H13.3433C13.5202 5.33398 13.6897 5.26375 13.8147 5.13872C13.9398 5.0137 14.01 4.84413 14.01 4.66732C14.01 4.49051 13.9398 4.32094 13.8147 4.19591C13.6897 4.07089 13.5202 4.00065 13.3433 4.00065ZM6.67668 3.33398C6.67668 3.15717 6.74691 2.9876 6.87194 2.86258C6.99696 2.73756 7.16653 2.66732 7.34334 2.66732H8.67668C8.85349 2.66732 9.02306 2.73756 9.14808 2.86258C9.27311 2.9876 9.34334 3.15717 9.34334 3.33398V4.00065H6.67668V3.33398ZM11.3433 12.6673C11.3433 12.8441 11.2731 13.0137 11.1481 13.1387C11.0231 13.2637 10.8535 13.334 10.6767 13.334H5.34334C5.16653 13.334 4.99696 13.2637 4.87194 13.1387C4.74691 13.0137 4.67668 12.8441 4.67668 12.6673V5.33398H11.3433V12.6673Z"
              fill="#EA5455"
            />
          </svg>
          Delete
        </DeleteButton>
      </Stack>
    </Stack>
  );
};
